// pages/PageLayout.tsx
import { useIsAuthenticated } from '@azure/msal-react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import { ThemeProvider } from '@mui/material/styles';
import BluuTheme from 'assets/BluuTheme';
import { Sidebar } from 'components/ui';
import GlobalSpinnerLoader from 'components/ui/GlobalSpinnerLoader';
import useWindowsDimension from 'functions/useWindowsDimension';
import { Box, Button } from '@mui/material';
import { rq } from 'http/apiRoutes';
import { useGet } from 'http/useApi';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { modulesAvailable } from './Modules/modulesAvailable';
import { delay } from 'lodash';

export interface DashboardStats {
  companies: number;
  newCompanies: number;
  tickets: number;
  newTickets: number;
  orders: number;
  newOrders: number;
  products: number;
  newProducts: number;
  invoices: number;
  newInvoices: number;
  feedbacks: number;
  newFeedbacks: number;
}

const DashboardStatsDefault: DashboardStats = {
  companies: 0,
  newCompanies: 0,
  tickets: 0,
  newTickets: 0,
  orders: 0,
  newOrders: 0,
  products: 0,
  newProducts: 0,
  invoices: 0,
  newInvoices: 0,
  feedbacks: 0,
  newFeedbacks: 0,
};

const PageLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { height, width } = useWindowsDimension();
  const isAuthenticated = useIsAuthenticated();
  const [dashboardStats, setDashboardStats] = React.useState(
    DashboardStatsDefault
  );
  const refreshQty = isAuthenticated;
  const tenantIdStr =
    localStorage.getItem('tenantId') ??
    localStorage.getItem('selectedTenantId') ??
    null;
  const shouldFetchEmail =
    isAuthenticated && tenantIdStr === '33333333-4444-5555-6666-777777777777';

  const { refetch: refetchQty } = useGet(rq.qty(refreshQty));
  const { refetch: refetchEmail } = useGet(rq.getEmail(shouldFetchEmail));

  useEffect(() => {
    if (!refreshQty) return;

    const fetchQty = () =>
      refetchQty().then((res: any) => {
        console.log('fetchQty @', new Date().toISOString(), res?.data);
        if (res?.data) {
          setDashboardStats({ ...DashboardStatsDefault, ...res.data });
        }
      });

    fetchQty();
    const intervalId = setInterval(fetchQty, 3 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, [refreshQty]);

/*   useEffect(() => {
    if (!shouldFetchEmail) return;

    const fetchEmail = () => {
      refetchEmail()
        .then((res: any) => {
          console.log('TTT fetchEmail @', new Date().toISOString(), res?.data);
        })
        .catch(() => null);
    };

    fetchEmail();
    const intervalId = setInterval(fetchEmail, 3 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, [shouldFetchEmail]); */

  let sidebarWidth = 0;
  if (width >= 1200) {
    sidebarWidth = 360;
  } else if (width >= 900) {
    sidebarWidth = 260;
  } else if (width >= 600) {
    sidebarWidth = 160;
  } else {
    sidebarWidth = 160;
  }

  const contentWidth = width - sidebarWidth;

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <ThemeProvider theme={BluuTheme}>
      <CssBaseline />

      <Grid
        container
        item
        xs={12}
        display='flex'
        direction='row'
        spacing={0}
        sx={{ m: 0, p: 0, width }}
      >
        <Grid item xs={12} sx={{ height: 10, m: 0, p: 0 }}>
          <GlobalSpinnerLoader />
        </Grid>

        <Grid
          item
          xs={2}
          sx={{
            m: 0,
            p: 0,
            // minWidth: sidebarWidth,
            height: height - 12,
          }}
        >
          <Sidebar
            dashboardStats={dashboardStats}
            sidebarWidth={sidebarWidth}
          />

          {tenantIdStr === '33333333-4444-5555-6666-777777777777' && 
            shouldFetchEmail && (
            <Box sx={{ 
              mr:1,
              p: 1, 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'center', 
              backgroundColor: 'primary.main' 
              }}>
              <Button
              fullWidth
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: 'primary.lighter',
                textTransform: 'none',
                letterSpacing: 2.2,
              }}
                size='small'
                variant='outlined'
                onClick={() => {
                  refetchEmail()
                    .then((res: any) => {
                      console.log('manual fetchEmail @', new Date().toISOString(), res?.data);
                    })
                    .catch(() => null);
                }}
              >
                GET EMAILS
              </Button>
            </Box>
          )}
        </Grid>

        <Grid
          item
          xs={10}
          sx={{
            m: 0,
            p: 0,
            // width: contentWidth,
            height: height - 12,
          }}
        >
  
          {!isAuthenticated ? (
            <div style={{ padding: '1rem' }}>Logger inn…</div>
          ) : (
            <Outlet />
          )}
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default PageLayout;
